import PropTypes from 'prop-types';
import { Link } from 'react-router';

import { ROUTES } from '#/config/routes';
import { Button } from '#/modules/commonComponents/button';
import SideMsg from '#/modules/commonComponents/SideMsg';
import RepairRequestCommandBar from '#/modules/crmMgmt/aftersales/repairRequest/components/RepairRequestCommandBar';
import {
  repairRequestSideMsgDetailBlock,
  repairRequestSideMsgStatusBlock,
} from '#/modules/crmMgmt/aftersales/repairRequest/data/repairRequestSideMsgConfig';

/** 側欄對齊物料列表：狀態 → 操作（詳情＋單據操作）→ 明細。 */
const RepairRequestSideMsg = ({ displayData, onRefetch, onDeleted }) => {
  const id = displayData?.id;

  const blocks = [
    repairRequestSideMsgStatusBlock,
    {
      condition: () => Boolean(id),
      fields: [
        {
          key: 'actions',
          label: '操作',
          render: () => (
            <div className="side_msg-row">
              <h3>操作</h3>
              <div className="flex flex-wrap items-center gap-2">
                <Button type="button" variant="outline" asChild>
                  <Link to={ROUTES.repairRequestDetail(id)}>詳情</Link>
                </Button>
                <RepairRequestCommandBar
                  key={`${id}-${displayData?.record?.updatedAt ?? ''}`}
                  detail={displayData}
                  onRefetch={onRefetch}
                  onDeleted={onDeleted}
                />
              </div>
            </div>
          ),
        },
      ],
    },
    repairRequestSideMsgDetailBlock,
  ];

  return (
    <SideMsg
      title="報修單"
      titleValue="repairRequestNo"
      displayData={displayData}
      blocks={blocks}
    />
  );
};

RepairRequestSideMsg.propTypes = {
  displayData: PropTypes.object,
  onRefetch: PropTypes.func,
  onDeleted: PropTypes.func,
};

export default RepairRequestSideMsg;
